// Media feature flags - type and defaults defined here in one source of truth

// With this type we ensure the object will contain all the flags

export var supportedProducts = ['confluence', 'jira'];